import { AccountAnalysisState } from '@core/model/domain/accountAnalysisState';
import { Mapper } from '@core/model/framework/mapper';
import { CaseClerkDto } from '@core/service/digital-factory/account/types/dto/caseClerkDto';
import { injectable } from 'inversify';

@injectable()
export class AccountAnalysisStateMapper implements Mapper<AccountAnalysisState, CaseClerkDto> {
  toDomain(caseClerkDto: CaseClerkDto): AccountAnalysisState {
    const { status, lastError } = caseClerkDto;

    switch (status) {
      case 'WAITING_FOR_EXPLOITABLE_ANALYSIS':
        if (lastError === 'INSUFFICIENT_INCOME') {
          return 'INSUFFICIENT_INCOME';
        }
        return 'RETRY_ACCOUNT';
      case 'ANALYSIS_IN_PROGRESS':
        return 'IN_PROGRESS';
      case 'SUCCEEDED':
        return 'SUCCESS';
      case 'TOO_MANY_ATTEMPTS':
      case 'ABORTED':
      case 'FAILED':
      default:
        return 'FAILED';
    }
  }
}
